import { cva } from "cva";

export const expandingMenuItemStyles = cva({
  base: "px-horizontal-margin py-16 w-full text-ginto-18 font-ginto font-normal leading-100",
});
